import {
    axios,
    AxiosHelper,
    LocalStorageHelper,
    LocalStorageKey
} from "common/helpers"

export function requestPasswordReset(email) {
    if (window['cordova']) {
        return axios.post("https://app.forsale-s.com/api/auth/requestPasswordReset", { email })
    } else {
        return axios.post("/api/auth/requestPasswordReset", { email })
    }
}

export function resetPassword(payload) {
    if (window['cordova']) {
        return axios.post("https://app.forsale-s.com/api/auth/resetPassword", payload)
    } else {
        return axios.post("/api/auth/resetPassword", payload)
    }
}

export function login(payload) {
    if (window['cordova']) {
        return axios.post("https://app.forsale-s.com/api/auth/login", payload)
    } else {
        return axios.post("/api/auth/login", payload)
    }
}

export function verifyEmail(payload) {
    if (window['cordova']) {
        return axios.post("https://app.forsale-s.com/api/auth/verifyEmail", payload)
    } else {
        return axios.post("/api/auth/verifyEmail", payload)
    }
}

export function logout() {
    return AxiosHelper.logout()
}

export function getLoggedInUser() {
    return new Promise(resolve => {
        resolve(LocalStorageHelper.getItem(LocalStorageKey.User))
    })
}
